export { default } from "./Typography"
export { Heading } from "./Headings"
export { Paragraph } from "./Paragraph"
